export enum ProductReferenceType {
  SIMILAR = 'SIMILAR',
  COMPATIBLE = 'COMPATIBLE'
}
